import * as pfweb from './modules/pfweb'

export const getPfmMonthStatusText = pfweb.getPfmMonthStatusText
export default pfweb.default